import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { upiDetails } from "../../../ApiServices/ApiServices";
import { handleError, handleSuccess } from "../../../Utils";

const UserUPIID = ({
  setIsVisible,
  setIsUPIConnected,
  upiId,
  setUpiId,
  userName,
  setUserName,
}) => {
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!upiId || !userName) {
      setError("Both fields are required.");
      return;
    }
    try {
      const formData = {};
      formData.upiId = upiId;
      formData.userName = userName;
      const res = await upiDetails(formData);
      setError("");
      handleSuccess(res?.message);
      setIsVisible(false);
      setIsUPIConnected(true);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-6 mx-2 rounded-2xl shadow-lg w-full max-w-md">
        <div className="flex justify-between items-center mb-4 relative">
          <h2 className="text-xl font-semibold">Enter UPI Details</h2>
          <div
            onClick={() => setIsVisible(false)}
            className="cursor-pointer absolute top-[-15px] right-[-15px]"
          >
            <CloseIcon />
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">UPI ID</label>
            <input
              type="text"
              value={upiId}
              onChange={(e) => setUpiId(e.target.value)}
              placeholder="e.g. yourname@upi"
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">User Name</label>
            <input
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="e.g. UPI User Name"
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}

          <button
            onClick={handleSubmit}
            className="w-full py-2 bg-black text-white font-semibold rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserUPIID;
